export default class CirclesDispenser_CircleContour
{
    constructor(cParams)
    {
        this.saveParams(cParams);
    }
    
    compute()
    {
        if (this.isSingleCircle()) this.setOnCenter();
        else this.setOnCircleContour();
    }
    
    // Private:
    saveParams(cParams)
    {
        this._circles = cParams.circles;
        this._factor = cParams.factor;
    }
    
    setOnCenter()
    {
        let circle = this._circles[0];
        circle.x = 0;
        circle.y = 0;
    }

    setOnCircleContour()
    {
        this.computeOrbitRadius();
        let circles = this._circles;
        let theta = 0;
        circles.forEach((circle,i) => {
            const itIsNotFirstCircle = i !== 0;
            if (itIsNotFirstCircle) theta = this.computeTheta(i,theta);
            this.setPosition(circle,theta);
        });
    }

    computeOrbitRadius()
    {
        const k = this._factor;
        this.computePerimeter();
        const perimeter = this._orbitPerimeter;
        const R = k*perimeter/(2*Math.PI);
        this._orbitRadius = R;
    }

    computeTheta(i,theta0)
    {
        const P = this._orbitPerimeter;
        const circles = this._circles;
        const circle = circles[i];
        const circle0 = circles[i-1];
        const r = circle.radius;
        const r0 = circle0.radius;
        const theta = theta0 + 2*Math.PI*(r+r0)/P;
        return theta;
    }

    computePerimeter()
    {
        let perimeter = 0;
        const circles = this._circles;
        circles.forEach(circle => {
            const R = circle.radius;
            perimeter += 2*R;
        });
        this._orbitPerimeter = perimeter;
    }

    setPosition(circle,theta)
    {
        const R = this._orbitRadius;
        circle.x = R*Math.cos(theta);
        circle.y = R*Math.sin(theta);
    }
    
    isSingleCircle()
    {
        const circles = this._circles;
        if (circles.length === 1) return true;
        else return false;
    }
    
}